import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../../api/services/authService";
import { useWorkspace } from "../../integrationQA/context/WorkspaceContext";
import AuthLayout from "./AuthLayout";
import { AuthField, PasswordField } from "./AuthField";

function SessionExpired() {
  const navigate = useNavigate();
  const { applySession } = useWorkspace();
  const [email,setEmail]=useState(""); const [password,setPassword]=useState(""); const [error,setError]=useState(""); const [success,setSuccess]=useState(false); const [busy,setBusy]=useState(false);
  const submit=async e=>{
    e.preventDefault();setError("");
    if(!email.trim()||!password)return setError("Email and password are required.");
    setBusy(true);
    try{
      const session=await login(email.trim(),password);
      setSuccess(true);
      setTimeout(()=>{applySession(session);navigate("/dashboard",{replace:true});},700);
    }catch(err){
      setError(err.code==="INVALID_CREDENTIALS"?"Invalid email or password. Please try again.":(err.message||"Unable to sign in."));
      setBusy(false);
    }
  };
  return (
    <AuthLayout title="Session Expired" subtitle="Your session has expired. Please sign in again." footer={<button type="button" className="auth-link" onClick={() => navigate("/login")}>Back to Login</button>}>
      {success ? <div className="auth-success" role="status">Re-authentication successful.</div> : (
        <form onSubmit={submit} noValidate>
          <AuthField label="Email address" icon="bi-envelope" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email Address" autoComplete="email" />
          <PasswordField value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" autoComplete="current-password" />
          {error && <div className="auth-error" role="alert">{error}</div>}
          <button className="auth-primary" disabled={busy}>{busy ? "Signing in…" : "Sign In Again"}</button>
        </form>
      )}
    </AuthLayout>
  );
}
export default SessionExpired;
